<template>
  <div class="finished">
    <StepContent>
      <div class="finished-content">
        <div class="text-left sm:text-center md:mx-auto md:text-left lg:max-w-530">
          <div class="finished-content__header">
            <FontAwesomeIcon
              slot="iconRight"
              class="finished__check xs-only:hidden"
              icon="circle-check"
              :class="textColorClass()"
            />

            <h1 class="text-2xl sm:pl-20 md:text-5xl">
              You're All Set!
            </h1>
          </div>
          <div class="finished-content-_body">
            <p
              :class="textColorClass()"
              class="mt-10 font-bold"
            >
              Confirmation Number : {{ confirmationNumber }}
            </p>
            <br>
            <p class="font-body">
              Congratulations on signing up for <span class="font-bold"> {{ foundationTitle }} </span>.
            </p>
            <br>
            <p>
              You've taken an important step in improving your financial future.
            </p>
            <br>
            <p class="font-bold text-lg">
              Here is what happens next:
            </p>
            <br>
            <p class="font-bold">
              Check your inbox!
            </p>
            <p>
              You will have received an email with your first payment date and frequency.
            </p>
            <br>
            <p>
              If you have any questions or concerns, feel free to chat with us <span
                :class="textColorClass()"
                class="underline cursor-pointer"
                @click="triggerChat()"
              >here</span>.
            </p>
            <br>
            <p>
              You can learn more about <span class="font-bold">The Foundation</span> at our help centre <a
                :class="textColorClass()"
                class="underline cursor-pointer"
                :href="helpCentreUrl"
                target="_blank"
              >here</a>.
            </p>
          </div>
        </div>
        <div class="finished-content__card">
          <PlanSelectionCardReadOnly
            :theme="theme"
            class="min-w-300 xs:min-w-340 max-w-340"
          />
          <div class="text-center mt-10">
            <span class="opacity-30">
              *Payment Amounts may vary slightly.
            </span>
          </div>
        </div>
      </div>
    </StepContent>
    <FreshChat
      :load-chat="loadChat"
      @close-chat="loadChat = false"
    />
  </div>
</template>

<script>
import StepContent from '@/components/common/step-layout/StepContent'
import DataLayer from '@/utilities/data-layer'
import theme from '@/mixins/theme'
import PlanSelectionCardReadOnly from '@/components/common/cards/PlanSelectionCardReadOnly'
import confirmationNumber from '@/mixins/confirmation-number'
import FreshChat from '@/components/widgets/freshchat/FreshChat'
import chatHandler from '@/mixins/freshchat/chat-handler'

export default {
  name: 'ApplicationSuccessful',

  components: {
    StepContent,
    FreshChat,
    PlanSelectionCardReadOnly
  },

  mixins: [
    theme,
    confirmationNumber,
    chatHandler
  ],

  computed: {
    foundationTitle () {
      return this.isFoundationGold ? 'The Foundation Gold' : 'The Foundation Basic'
    },

    isFoundationGold () {
      return this.$store.state.foundation.isFoundationGold
    },

    returningCustomerSubmitted () {
      return this.$store.state.application.returningCustomerSubmitted
    },

    customerFirstName () {
      return this.$store.state.customer.first_name
    },

    helpCentreUrl () {
      return `${process.env.VUE_APP_MINISITE_URL}help-centre`
    },

    returningCustomer () {
      return this.$store.state.returningCustomer.is_in_progress
    },

    leadSource () {
      return this.$store.state.tracking.lead_source
    },

    deviceType () {
      return this.$store.state.tracking.device_type
    }
  },

  created () {
    const eventDetails = {
      lead_source: this.leadSource,
      device: this.deviceType,
      returning_customer: this.returningCustomer
    }
    DataLayer.pushEvent('event', 'spring_foundation_app_finished', eventDetails)
    window.rudderanalytics.track('spring_foundation_app_finished', eventDetails)
  }
}
</script>

<style scoped lang="scss">
.finished {
  @apply text-center;

  &-content {
    @apply flex sm:justify-center flex-col lg:flex-row;

    &__header {
      @apply flex sm:justify-center md:justify-start;
    }

    &__body {
      @screen xs-only {
        @apply ml-5;
      }

      @screen sm {
        @apply text-center max-w-340 mx-auto;
      }

      @screen md {
        @apply text-left mx-0 max-w-none;
      }
    }

    &__card {
      @apply mt-10;

      @screen xs-only {
        @apply mr-10;
      }

      @screen sm {
        @apply mx-auto;
      }

      @screen md {
        @apply mr-auto ml-90;
      }

      @screen lg {
        @apply ml-0;
      }
    }
  }

  &__check {
    @apply mb-10 text-[40px];

    @screen lg {
      @apply text-[54px];
    }
  }
}
</style>
